import { PrimaryButton } from '@dot/design-system';
import { useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

const PrimaryButtonSC = styled(PrimaryButton)`
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const Container = styled.div`
  display: flex;
  margin-top: 30px;
  gap: 8px;
  justify-content: center;
`;

type ButtonsProps = {
  busy?: boolean;
  disabled: boolean;
};

export const Buttons = ({ busy = false, disabled }: ButtonsProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      <PrimaryButtonSC data-test-id="btn_intro_continue" disabled={disabled || busy} type="submit">
        {t('steps.introduction.continueButton')}
      </PrimaryButtonSC>
    </Container>
  );
};
